<template>
  <div class="container">
    <DeviceStatus />
    <DeviceCount />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import DeviceStatus from '@/components/common/metrics/DeviceStatus.vue';
import DeviceCount from '@/components/common/metrics/DeviceCount.vue';

@Component({
  components: {
    DeviceStatus,
    DeviceCount
  }
})
export default class Dashboard extends Vue {
}
</script>
<style lang="scss" scoped>
@import './styles/dashboard.scss';
</style>
